export default "__VITE_ASSET__c3c31384__"